import { useContext } from 'react';
import { HistoryContext } from 'providers/History';

const useHistory = () => useContext(HistoryContext);

export default useHistory;
